import { Box, Button, Dialog } from '@mui/material';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Loader } from 'shared/ui/Loader';

import { ModalContent } from './ModalContent';

type ModalProps = {
  children: ReactNode;
  isModalOpen: boolean;
  handleCloseModal: () => void;
  handleSubmitModal: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  approveNameButton: string;
  approveButtonColor?: string;
};

export const Modal = ({
  children,
  isModalOpen,
  handleCloseModal,
  handleSubmitModal,
  disabled,
  approveNameButton,
  isLoading,
  approveButtonColor = 'primary',
}: ModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isModalOpen} onClose={handleCloseModal}>
      <ModalContent
        onClose={handleCloseModal}
        buttons={
          <Box display="flex" justifyContent="flex-end" width="100%" gap="10px">
            <Button onClick={handleCloseModal}>{t('Cancel')}</Button>
            <Button
              startIcon={isLoading && <Loader color="inherit" />}
              onClick={handleSubmitModal}
              variant="contained"
              color={approveButtonColor as any}
              disabled={disabled}
              sx={{ textTransform: 'inherit' }}
            >
              {approveNameButton}
            </Button>
          </Box>
        }
      >
        {children}
      </ModalContent>
    </Dialog>
  );
};
